export const CHECKOUT_URL =
  "https://pay.hotmart.com/O102692836R?off=20z5v73u&checkoutMode=10&bid=1762798732573";

export const VIDEOS = { welcome: "9uLC4QfXBTA", charity: "huiuIC3xbqs" };

export const LEARN_CARDS = ["7", "8-1", "12", "6", "1", "5", "8", "3", "11", "10", "13", "9", "2", "4"].map(
  (n) => `/assets/card-${n}.webp`
);

export const APOSTILAS = [
  "apostila_livro_ervas_umbanda",
  "apostila_livro_obsessao",
  "apostila_mediunidade_livro",
  "apostila_sensacoes_e_percepcoes_png_livro",
  "apostila_sensitividade_por_afinidade_png_livro",
  "apostila_tipos_de_mediunidade_livro",
  "apostila_umbanda_png_livro",
  "apostila_habitos_para_o_bom_desenvolvimento_da_mediunidade_png_livro",
].map((n) => `/assets/${n}.webp`);

export const VALUE_ITEMS = [
  { text: "Curso de Mediunidade e Sensitividade", price: "R$497,00" },
  { text: "Ensinamento como montar altar e fazer banho de Ervas", price: "R$197,00" },
  { text: "Como plantar uma defesa energética na sua casa e no seu comércio", price: "R$97,00" },
  {
    text: "Aprendendo a atrair as energias de prosperidade financeira através dos elementais, cristais, ervas, sementes, cromoterapia etc",
    price: "R$197,00",
  },
  {
    text: "Aulas ao vivo na prática sobre Umbanda, Espiritualidade, Autoconhecimento e Nova Era Planetária",
    price: "R$297,00",
  },
  {
    text: "Conteúdos atualizados de como se prevenir das doenças psicossomáticas, como estresse, ansiedade entre outras",
    price: "R$97,00",
  },
  { text: "Quais hábitos e preceitos para um bom desenvolvimento mediúnico", price: "R$97,00" },
];

export const OFFER_INCLUDES = [
  "Acesso vitalício à Comunidade Umbanda para Todos",
  "Acesso vitalício a todos os cursos e aulas descritos durante o curso gratuito onde o professor apresentou as plataformas",
  "Aplicativo Hotmart pra você ver as aulas da comunidade pelo seu celular",
  "Plataforma de cursos profissionalizantes com certificação EspiritualFlix",
  "Aulas ao vivo toda semana",
  "Mentoria em grupo com o Sacerdote Edvilson",
  "Participe da seleção de assuntos abordados nos PodCasts",
  "Suporte direto com Professor e Equipe + Grupo da comunidade no Whats",
  "Estude diariamente onde e quando quiser",
  "Acesso aos podcasts novos",
];

export const OFFER_BONUS = [
  "Acesso vitalício à maior plataforma de espiritualidade com diversos cursos profissionalizantes, todos com certificados e apostilas, a EspiritualFlix",
  "Mentoria em grupo com o Sacerdote Edvilson",
  "Apostilas completas da comunidade",
  "Workshops, eventos, palestras, retiros e podcasts",
  "Tudo listado acima",
];

export const MARQUEE_WORDS = ["Umbanda para Todos", "Fundamento", "Respeito", "Amor", "Caridade", "Mediunidade", "Autoconhecimento"];
